export default __webpack_public_path__ + "51f9a9077612db286689245f892c8d1b.png";